<script setup lang="ts">
import type { TooltipPlacement } from 'vidstack';

import Tooltip from '../Tooltip.vue';
import { localize } from '@/front/composables/StringComposer'

const { tooltipPlacement } = defineProps<{
  tooltipPlacement: TooltipPlacement;
}>();
const handleClick = (event) => {
  event.stopPropagation()
  event.preventDefault()
}
</script>

<template>
  <Tooltip :placement="tooltipPlacement">
    <template #trigger>
      <media-play-button
        class="w-8 h-8 @lg/player:w-10 @lg/player:h-10 @2xl/player:w-12 @2xl/player:h-12 ring-media-focus relative inline-flex cursor-pointer items-center justify-center rounded-md outline-none ring-inset hover:bg-white/20 data-[focus]:ring-4"
        @click.stop="handleClick"
        >
        <media-icon class="media-paused:block hidden" type="play" />
        <media-icon class="media-paused:hidden" type="pause" />
      </media-play-button>
    </template>

    <template #content>
      <span class="media-paused:block hidden">{{ localize('play') }}</span>
      <span class="media-paused:hidden">{{ localize('pause') }}</span>
    </template>
  </Tooltip>
</template>
